// extracted by mini-css-extract-plugin
module.exports = {"firstFold":"firstFold_firstFold__sCdFX","bgImage":"firstFold_bgImage__Fopa9","heading":"firstFold_heading__Nf29I","subParagraph":"firstFold_subParagraph__PmRF1"};